import DoAPICall from './DoAPICall'

//Create Client SMS Channel
    export async function createClientSMSChannel(userToken, clientSMSChannel){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'clientsmschannels',
            payLoad:{
                client_id:clientSMSChannel.client_id,
                sms_provider_id:clientSMSChannel.sms_provider_id,
                description:clientSMSChannel.description,
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All Client SMS Channel
    export async function getClientSMSChannels(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientsmschannels',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Client SMS Channel
    export async function getClientSMSChannel(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientsmschannels/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get mnos of client
export async function getSMSChannelsOfClient(userToken,client_id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'smschannelsofclient/'+client_id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Update Client SMS Channel
    export async function updateClientSMSChannel(userToken, clientSMSChannel){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'clientsmschannels/'+clientSMSChannel.id,
            payLoad:{
                description:clientSMSChannel.description,
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete Client SMS Channel
    export async function deleteClientSMSChannel(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'clientsmschannels/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }
